import { thresholds } from '../../PagesContent/DigitalTwin/TabsSection/BatteryVitals/_Constants';

function FindTheThresholdMetrics(level,metric) {
    return thresholds[level][metric]
}

export default FindTheThresholdMetrics;